// Das Zeichen der Fragen (Gernot beim Augentest E3, 21.10.2026: „ein
// eigenes Design und Schema … überall gleich, dezent, aber nicht zu
// übersehen“): ein runder Kreis in Kohle mit dem Fragezeichen in Lime. Es
// steht überall, wo es um Fragen geht – am Knopf „Frage stellen“, an der
// Marke „1 offene Frage“, im Band oben. Dazu das runde Zeichen mit den
// Buchstaben dessen, der fragt oder antwortet.
//
// Eine eigene kleine Datei ohne weitere Abhängigkeiten, weil auch der
// Rahmen (das Band oben auf jeder Seite) sie braucht.

import { Ikon } from "@happy-energy/oberflaeche";
import { initialen } from "../anzeige.ts";
import "./fragen.css";

/** Der Kreis mit dem Fragezeichen – `gross` im Band oben. */
export function FrageZeichen({ gross = false }: { gross?: boolean }) {
  return (
    <span className={`frage-zeichen${gross ? " gross" : ""}`} aria-hidden="true">
      {/* Seit E3b (O81 a): nur das Fragezeichen im Kreis – das Symbol „frage“ trug noch einen eigenen Kreis. */}
      <Ikon name="fragezeichen" {...(gross ? {} : { groesse: "k" as const })} />
    </span>
  );
}

/** Das runde Zeichen mit den Buchstaben – `klein` an einer Antwort. Der Name steht daneben in Worten. */
export function FrageAvatar({ name, klein = false }: { name: string; klein?: boolean }) {
  return (
    <span className={`frage-avatar${klein ? " klein" : ""}`} aria-hidden="true">
      {initialen(name)}
    </span>
  );
}
